import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import APIHero from './components/APIHero';
import QuickStartGuide from './components/QuickStartGuide';
import APIEndpoints from './components/APIEndpoints';
import SDKLanguages from './components/SDKLanguages';
import WebhooksSection from './components/WebhooksSection';
import RateLimits from './components/RateLimits';
import SupportResources from './components/SupportResources';

const APIDocumentation = () => {
  return (
    <>
      <Helmet>
        <title>API Documentation - PolicyAlerts | Enterprise Integration Resources</title>
        <meta 
          name="description" 
          content="Complete API documentation for PolicyAlerts. Integrate medical policy monitoring into your healthcare technology platform with our enterprise-grade REST API, webhooks, and SDKs." 
        />
        <meta name="keywords" content="PolicyAlerts API, medical policy API, healthcare integration, policy monitoring API, enterprise API documentation, medical device policy tracking" />
      </Helmet>

      <div className="min-h-screen flex flex-col bg-background">
        <Header />
        
        <main className="flex-1">
          <APIHero />
          <QuickStartGuide />
          <APIEndpoints />
          <SDKLanguages />
          <WebhooksSection />
          <RateLimits />
          <SupportResources />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default APIDocumentation;